export default __webpack_public_path__ + "static/media/emojiClap.6633e131.svg";